import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import es from 'vuetify/lib/locale/es';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { es },
    current: 'es',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#05053e',
        secondary: '#1B1BAF',
        selected: '#E6E6F9',
        success: '#43BC82',
        error: '#FA8B00',
        base1: '#4edadd',
        base2: '#7373e0',
        base3: '#1b1baf',
        base4: '#D6D6EE',
        base5: '#E9E9F4',
        base6: '#6A83B5',
        base7: '#a3a3da',
        base8: '#28D7DB',
        bkground: '#F2F6FF',
        bkgSecundary: '#3b3b66',
        naranja: '#FFC955',
        naranja2: '#FEF6E0',
        naranja3: '#FEC240',
        azul1: '#E1F2FF',
        azul2: '#6A83B5',
        verde1: '#e2f7e9',
        verde2: '#74b782',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
